import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/faixaEtaria`;

export const getFaixasExtarias = async () => {
  return await axios.get(`${httpUrl}/list`).then((response) => response);
};
